import { BadgeProps } from '../base/badge'

export const contactTypes: Record<string, { name: string, color: BadgeProps['color'] }> = {
  technical: { name: 'Technical', color: 'red' },
  management: { name: 'Management', color: 'green' },
  facilities: { name: 'Facilities', color: 'blue' },
  security: { name: 'Security', color: 'yellow' },
  other: { name: 'Other', color: 'purple' },
}
